import { gql } from 'graphql-request';
import { baseApi } from './baseApi';

export const conceptZoneApi = baseApi.injectEndpoints({
  endpoints: (builder: any) => ({
    // queries
    getConceptZones: builder.query({
      query: () => ({
        body: gql`
          query Query($subsiteShortCode: String!) {
            findConceptZones(subsite_short_code: $subsiteShortCode) {
              id
              name
              description
              code
              main_color
              secondary_color
            }
          }
        `,
        variables: {
          subsiteShortCode: 'dvr',
        },
      }),
      transformResponse: (res: any) => res.findConceptZones,
    }),
  }),
  overrideExisting: false,
});

export const { useGetConceptZonesQuery, useLazyGetConceptZonesQuery } = conceptZoneApi;
